function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.79071 6.85714H9.76745V10.2857H2.79071V6.85714Z",
  fill: "#45B879"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.76746 3.42857H16.7442V6.85715H9.76746V3.42857Z",
  fill: "#E84553"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.79071 10.8571H16.7442V12.1429H2.79071V10.8571ZM2.79071 12.1429H16.7442V14.7143H9.69803H2.79071V12.1429ZM16.7442 14.7143H2.79071V16H16.7442V14.7143Z",
  fill: "#959595"
});

var SvgIconOrderBookDefaultActive = function SvgIconOrderBookDefaultActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOrderBookDefaultActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconOrderBookDefaultActive.2716ab85.svg";
export { ForwardRef as ReactComponent };